import { Component, Input, OnInit } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { CaseService } from '../case.service';
import { Case } from '../case.model';
import { ActivatedRoute, Router } from '@angular/router';
import { Share } from '@capacitor/share';
import { environment } from 'src/environments/environment';
import { CommentsModalComponent } from 'src/app/shared/comments-modal/comments-modal.component';
import { AuthService } from 'src/app/auth/auth.service';
@Component({
  selector: 'app-case-details',
  templateUrl: './case-details.page.html',
  styleUrls: ['./case-details.page.scss'],
})
export class CaseDetailsPage implements OnInit {
  selectedCase: Case;
  caseType: string;
  isLoading = true;
  userId = 0;
  commentsCount = 0;
  constructor(
    private caseService: CaseService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private modalCtrl: ModalController,
    private authService: AuthService,
    private alertCtrl: AlertController
  ) { }

  async ngOnInit() {
    this.userId = await this.authService.getUserId();
    const caseId = +this.activatedRoute.snapshot.params.id;
    this.caseService.getCaseById(caseId).subscribe((res) => {
      this.selectedCase = res;
      this.commentsCount = this.selectedCase.commentsCount;
      switch (this.selectedCase.type) {
        case 'adoption': {
          this.caseType = 'FOR ADOPTION';
          break;
        }
        case 'lost': {
          this.caseType = 'LOST PET';
          break;
        }
        case 'found': {
          this.caseType = 'FOUND PET';
          break;
        }
        case 'foster': {
          this.caseType = 'FOSTER NEEDED';
          break;
        }
        case 'cashdonation': {
          this.caseType = 'CASH DONATION NEEDED';
          break;
        }
        case 'supplies': {
          this.caseType = 'Pet Supplies Donation Needed';
          break;
        }
        case 'report': {
          this.caseType = 'CRUELTY REPORT';
          break;
        }

        default: {
          this.caseType = 'OTHER';
          break;
        }
      }
      this.isLoading = false;
      const openComment =
        this.activatedRoute.snapshot.queryParams['openComment'];
      if (openComment == 'true') {
        this.ViewComments(this.selectedCase.id, this.selectedCase.userid);
      }
    });
  }

  async shareCase() {
    const url = environment.appUrl + this.router.url;
    await Share.share({
      title: 'Help Needed',
      text: `Can you help with this case? ${url}`, // Combine text and URL
    });
  }

  ViewComments(caseId: number, caseUserId: number) {
    if (this.userId <= 0) {
      this.ShowLoginAlert();
      return;
    }
    this.modalCtrl
      .create({
        component: CommentsModalComponent,
        componentProps: {
          caseId,
          userId: this.userId,
          postUserId: caseUserId,
          source: 'case',
        },
      })
      .then((modalEl) => {
        modalEl.onDidDismiss().then((modalData) => {
          if (!modalData.data) {
            return;
          }
          this.selectedCase.commentsCount = modalData.data['commentsCount'];
          this.commentsCount = this.selectedCase.commentsCount;
        });
        modalEl.present();
      });
  }


  ShowLoginAlert() {
    this.alertCtrl
      .create({
        header: 'Sign In Reqiured',
        message: 'You need to sign in first to view or add comments',
        buttons: [
          {
            text: 'Dismiss',
            handler: () => {
              this.alertCtrl.dismiss();
            },
          },
          {
            text: 'Sign in',
            handler: () => {
              this.router.navigateByUrl('/signin?redirectURL=' + this.router.url);
            },
          },
        ],
      })
      .then((alertEl) => alertEl.present());
  }
}
